<template>
  <div class="send_gift_box" :class="{'send_gift_box-z-index':sendGiftImgSrc,'z-index-30':giftStatus==='close'}"> 
    <div class="send_gift_close cursor" v-show="giftStatus==='close'" @click="changeStatus"></div>
    <transition name="send_gift">
      <div class="send_gift" v-show="giftStatus==='show'">
        <div class="gift_list">
          <dl v-for="(item,i) in giftData.list" :class="{'dl-active':clickData.giftId===item.giftId}" class="cursor" :key="i" @click="giftClick(item)">
            <dd><img :src="giftData.baseUrl+item.imageUrl" ondragstart="return false" alt=""></dd>
            <dt>{{item.name}}</dt>
            <dt>{{item.coin}}金币</dt>
          </dl>
        </div>
        <div class="send_btn">
          <div class="close cursor" @click="giftStatus='close'"></div>
          <p>我的金币：{{coinAllnum}}</p>
          <button class="cursor sendbtn" v-show="sendStatus==='default'" @click="sendData">立即赠送</button>
          <button v-show="sendStatus==='loading'" class="disabled"><img src="../../../../assets/img/common/loading1.gif" alt=""></button>
        </div>
      </div>
    </transition>
    <Toast
      :showText="showText"
      v-if="showText"
      :waitTime="2000"
      @toastCallBack="showText=''"
    />
    <alert v-if="alertData.name" :data="alertData" @cancelEvent="alertData={}" @ensure="send"></alert>
    <div class="send-success" v-show="sendGiftImgSrc">
      <div class="pic">
          <img class="img1" src="/static/img/video/light.png" alt ondragstart="return false;">
          <img class="img2" :class="{'imgscale':sendGiftImgSrc}" :src="sendGiftImgSrc" alt ondragstart="return false;">
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import lottie from "lottie-web-limi";
import Toast from "@/components/basic/toast.vue"; //Toast
import alert from "./alert.vue"; //Toast
export default {
  name: "sendGift",
  data() {
    return {
      clickData: "",
      giftStatus: "show",
      showText: "",
      sendStatus: "default",
      sendInterval: null,
      sendGiftImgSrc:'',
      alertData:{},
    };
  },
  components: {
    Toast,
    alert
  },
  props: {
    giftData: {
      //控制自定表情话术的显示和隐藏
      default: {},
      type: Object
    }
  },
  computed: {
    ...mapState(["coinAllnum", "giftSwitchUniqueId"])
  },
  created() {
    this.eventHub();
  },
  mounted() {
    this.$nextTick(this.animInit);
  },
  methods: {
    //获取自定义表情和话术
    ...mapMutations(["updateAllCoin"]),
    changeStatus(){
      if(this.$parent.a_on_off || this.$parent.iframeQuickId)return;
      this.giftStatus='show';
    },
    animInit() {
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".send_gift_close"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "/static/lottie/giftentrance/a.json"
      });
    },
    eventHub() {
      this.$root.eventHub.$on("sendGiftResult", res => {
        if (res.code == -1) {
          this.showText = "当前金币不足";
        } else if (res.code == 1) {
          this.giftStatus = "close";
          let imgSrc = this.giftData.baseUrl + this.clickData.imageUrl;
          let allnum = this.coinAllnum -(this.clickData.coin || 0);
          this.updateAllCoin(allnum);
          setTimeout(()=>{
             this.sendGiftImgSrc = imgSrc;
          },400)
          setTimeout(()=>{
            this.sendGiftImgSrc = ""
          },2400)
        } else {
          this.showText = "赠送失败，请重试";
        }
        this.clickData = "";
        this.sendStatus = "default";
        clearInterval(this.sendInterval);
      });
    },
    giftClick(item) {
      if(this.sendStatus === "loading") return;
      this.clickData = this.clickData.giftId === item.giftId ? "" : item;
    },
    sendData() {
      if (!this.clickData) {
        this.showText = "请先选择礼物";
        return;
      }
      if (!navigator.onLine) {
        this.showText = "赠送失败，网络无连接";
        return;
      }
      this.alertData = this.clickData
    },
    send(){
      this.alertData = {};
      this.sendStatus = "loading";
      this.$root.eventHub.$emit("sendGift", {
        giftId: this.clickData.giftId,
        sendUniqueId: this.giftSwitchUniqueId
      });
      this.sendInterval = setTimeout(() => {
        this.showText = "赠送失败，请重试";
        this.sendStatus = "default";
      }, 10 * 1000);
    }
  },
  beforeDestroy() {
    this.anim && this.anim.destroy();
    clearInterval(this.sendInterval);
    this.$root.eventHub.$off("sendGiftResult");
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.send_gift_box {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 96;
}
.send_gift_box-z-index{
  z-index: 80;
}
.z-index-30{
  animation: zIndex 0s .6s;
  animation-fill-mode:forwards;
}
@keyframes zIndex {
  from{
    z-index: 96;
  }
  to{
    z-index: 30;
  }
}
.send_gift {
  width: 100%;
  background: #434343;
  padding: 24px 0;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.send_gift_close {
  width: 87px;
  height: 87px;
  position: absolute;
  bottom: 250px;
  left: 50px;
}
.gift_list {
  display: flex;
  max-width: 768px;
  min-width: 200px;
  dl {
    width: 130px;
    margin-right: 62px;
    overflow: hidden;
    border-radius: 6px;
    img {
      width: 128px;
      height: 97px;
    }
    dd {
      margin-bottom: 6px;
    }
    dt:nth-child(2) {
      font-size: 18px;
      color: #ffffff;
    }
    dt:nth-child(3) {
      font-size: 16px;
      color: #ffffff;
      opacity: 0.5;
      padding-bottom: 10px;
    }
  }
  .dl-active {
    background: #54617b;
    img {
      animation: imgScale 1.3s infinite ease;
    }
  }
}
.send_btn {
  position: relative;
  border-left: 1px solid rgba(151, 151, 151, 0.6);
  padding-left: 50px;
  margin-top: 15px;
  min-width: 200px;
  p {
    color: #ffffff;
    margin-bottom: 20px;
  }
  button {
    width: 144px;
    height: 53px;
    background: #008acf;
    border-radius: 26px;
    font-size: 20px;
    color: #ffffff;
    line-height: 53px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .sendbtn:hover {
    background: #4cadde;
  }
  .disabled {
    pointer-events: none;
    background: #3991bd;
    color: #9cc8de;
  }
  .close {
    position: absolute;
    top: -115px;
    left: 100px;
    width: 45px;
    height: 30px;
    background: url(../../../../assets/img/video/close_gift.png) no-repeat;
    background-size: contain;
  }
}
.send-success {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 80;
  .pic {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -170px;
    margin-top: -170px;
    height: 340px;
    width: 340px;
    .img1 {
      height: 100%;
      width: 100%;
      animation: rotateMotivate 18s infinite linear;
    }
    .img2 {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 360px;
      margin-left:-180px;
      margin-top: -130px;
    }
    .imgscale{
      transform: scale(0);
      animation: giftScale 1s linear;
      animation-fill-mode: both;
    }
  }
}
.send_gift-enter-active {
  animation: slideTop 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.send_gift-leave-active {
  animation: slideTop 0.4s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
@keyframes giftScale{
		0%{
      transform: scale(0);
    }
    55%{
      transform: scale(1.2);
    }
    70%{
      transform: scale(.9);

    }
    85%{
      transform: scale(1.1);
    }
		100%{
      transform: scale(1);
		}
	}
@keyframes imgScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/sendGift/sendGift.vue